import { useMutation } from '@tanstack/react-query'
import { adminReplyToCloseTicket } from '../index'

const useAdminReplyToCloseTicket = () => {
  return useMutation({
    mutationFn: ({
      payload,
    }: {
      payload: { ticketId: string | undefined; responseText: string }
    }) => adminReplyToCloseTicket(payload),
  })
}

export default useAdminReplyToCloseTicket
